module.exports = __webpack_public_path__ + "img/bar-chart-square-02.1f373d4a.svg";